module.exports = __webpack_public_path__ + "static/img/instantane.b5d2fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/instantane.jpg
// module id = 30
// module chunks = 0